import { AUTH_LOGOUT } from '../../../../../common/redux/actions/types/authActionTypes';
import {
  GET_ELEMENT_TYPES_SUCCESS,
  GET_ELEMENT_TYPES_FAILURE,
  EDIT_THRESHOLD_FAILURE,
  EDIT_THRESHOLD_SUCCESS,
} from '../actions/types/NotificationServiceActionTypes';

export const initialState = {
  elementTypes: [],
  isElementTypesLoaded: false,
  editMode: false,
  editChanges: null,
};
const NotificationServiceReducer = (state = initialState, action) => {
  switch (action.type) {
  case GET_ELEMENT_TYPES_SUCCESS:
    return {
      ...state,
      elementTypes: action.payload,
      isElementTypesLoaded: true,
    };
  case GET_ELEMENT_TYPES_FAILURE:
    return {
      ...state,
      elementTypes: [],
      isElementTypesLoaded: false,
    };
  case EDIT_THRESHOLD_FAILURE:
    return {
      ...state,
      editMode: true,
      editChanges: action.data,
    };
  case EDIT_THRESHOLD_SUCCESS:
    return {
      ...state,
      editMode: false,
      editChanges: null,
    };

  case AUTH_LOGOUT:
    return initialState;

  default:
    return state;
  }
};
export default NotificationServiceReducer;
